<template>
  <div>
        <h2>Chest</h2>
    <v-container v-if="!loading" class="py-10">
        <v-row>
            <v-col v-for="item in chest" class="shrink my-0 py-0" cols="12" md="4" :key="item.id">
                <v-checkbox
                        v-model="chestCheckbox"
                        :disabled="disableChest(item.id, item.is_normal)"
                        :label='item.name'
                        :value="item.id"
                        hide-details
                        @change="toggle => chestTick(item.id, toggle, item.is_normal)"
                />
            </v-col>
        </v-row>
        <v-row v-if="isChestRemark">
            <v-col>
                <v-text-field
                        placeholder="Other"
                        outlined
                        v-model="chest_remark"
                        :rules="[v => !!v || 'Chest Other is required']"
                        label="Chest Other"
                        @keyup="includeChestRemark"
                        required
                />
            </v-col>
        </v-row>
    </v-container>
    <v-container v-else style="text-align: center;">
      <v-progress-circular
        :size="150"
        color="primary"
        indeterminate
        style="text-align: center"
      >Loading Data
      </v-progress-circular>
    </v-container>
  </div>
</template>

<script>
    export default {
        name: "Chest",

        props: {
            formData: {
                type: Object,
                required: true,
            },
            config: Number
        },

        data() {
            return {
                isChestRemark: false,
                chest_remark: null,
                isChestNormal: false,
                chest: {},
                loading: true,
                chestCheckbox: []
            }
        },
        methods: {
            editFieldChest() {
                let vm = this;
                _.forEach(this.formData.physical_examination.chest, function(value) {
                    vm.chestCheckbox.push(Number.parseInt(value.chest_id));
                    if (value.chest_remark) {
                        vm.chest_remark = value.chest_remark;
                        vm.isChestRemark = true;
                    }
                });
            },

            disableChest(id, normal = 0, toggle = true) {
                let vm = this;
                _.forEach(this.formData.physical_examination.chest, function (value) {
                    if (Number.parseInt(value.chest_id) === Number.parseInt(id) && normal && toggle) {
                        vm.isChestNormal = true;
                    }
                });
                return this.chestCheckbox.indexOf(id) === -1 && this.isChestNormal;
            },

            chestTick(key, toggle, is_normal) {
                let toggled = toggle.includes(Number.parseInt(key));
                let chest = this.formData.physical_examination.chest;

                if (key === this.config) {
                    this.isChestRemark = !this.isChestRemark;
                }
                if (is_normal) {
                    this.isChestNormal = !this.isChestNormal;
                    this.chestNormalOnly(key, toggled);
                    this.disableChest(key, is_normal, toggled);
                }

                if (toggled) {
                    chest.push({
                        chest_id: key,
                        chest_remark: null,
                    });
                } else {
                    let index = chest.findIndex(chest => chest.chest_id === key);
                    chest.splice(index, 1);
                }
            },

            chestNormalOnly(key, toggled) {
                if (toggled) {
                    let chest = this.formData.physical_examination.chest;
                    chest.push({
                        chest_id: key,
                        chest_remark: null,
                    });
                    this.chestCheckbox = [key];
                    chest.splice(0, chest.length);
                    this.isChestRemark = false;
                }
            },

            includeChestRemark() {
                let chest = this.formData.physical_examination.chest;
                let index = chest.findIndex(chest => chest.chest_id === this.config);
                chest.splice(index, 1);
                chest.push({
                    chest_id: this.config,
                    chest_remark: this.chest_remark,
                });
            },

            getChestLib() {
                this.axios.get('chest-lib', {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                    }
                }).then((response) => {
                    // handle success
                    this.chest = response.data;
                    this.loading = false;
                }).catch((error) => {
                    // handle error
                    console.error(error);
                }).finally(() => {
                    // always executed
                });
            },
        },

        mounted() {
            this.getChestLib();
            this.editFieldChest();
        }
    }
</script>

<style scoped>

</style>